<template>
  <div class="calendar-layout container">
    <div>
      <CalendarMainView :current-month="monthSelected"
                        @changeMonth="onMonthChanged($event)"/>
    </div>
    <div>
      <CalendarInfo :current-month="monthSelected"
                    :date-selected="dateSelected"
                    @changeMonth="onMonthChanged($event)"
                    @addTransaction="openTransactionModal = !openTransactionModal"/>
    </div>
    <CreateTransactionModal v-if="openTransactionModal"
                            :transaction-date="predictedNewTransactionDate"
                            @success="handleSuccessModal"
                            @close="openTransactionModal = false"/>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import CalendarInfo from "@/components/cabinet/Money/Calendar/CalendarInfo/CalendarInfo";
import CalendarMainView from "@/components/cabinet/Money/Calendar/CalendarMainView";
import CreateTransactionModal from "@/components/common/CreateTransaction/CreateTransactionModal";

export default {
  name: "TheCalendar",
  components: {CreateTransactionModal, CalendarMainView, CalendarInfo},
  data() {
    return {
      openTransactionModal: false
    }
  },
  computed: {
    ...mapState('space/calendar', ['monthSelected', 'dateSelected']),
    predictedNewTransactionDate() {
      return this.dateSelected ? this.dateSelected : this.$moment().format('YYYY-MM-DD');
    }
  },
  methods: {
    ...mapActions('space/calendar', ['fetchCalendar', 'fetchTransactions', 'fetchPlannedTransactions']),
    ...mapActions('space/calendar', ['onMonthChanged']),
    handleSuccessModal() {
      this.fetchCalendar();
      this.fetchTransactions();
      this.fetchPlannedTransactions();
      this.openTransactionModal = false;
    }
  },
  created() {
    this.onMonthChanged(this.$moment().format('YYYY-MM'));
  },
  mounted() {
    this.$store.dispatch('space/accounts/getAccounts');
    this.$store.dispatch('space/accounts/getAccountGroups');
    this.$store.dispatch('space/incomes/getIncomes');
    this.$store.dispatch('space/expenses/getExpenses');
    this.$store.dispatch('space/expenses/getExpenseGroups');
    this.$store.dispatch('space/tags/getTags');
    this.$store.dispatch('space/contractors/getContractors');
  }
}
</script>

<style lang="scss" scoped>
.calendar-layout {
  margin-top: 7px;
  display: grid;
  grid-template-columns:1fr;
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;
  padding-bottom: 80px;
  @media(min-width: 1200px) {
    grid-template-columns:670px 470px;
    grid-column-gap: 3rem;
    grid-row-gap: 3rem;
  }
}
</style>